var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7787 20.8235C17.4244 20.8235 21.1905 17.0575 21.1905 12.4118C21.1905 7.76608 17.4244 4 12.7787 4C8.13302 4 4.36694 7.76608 4.36694 12.4118C4.36694 12.7501 4.38692 13.0838 4.42576 13.4118H3.41944C3.38474 13.0832 3.36694 12.7495 3.36694 12.4118C3.36694 7.21379 7.58073 3 12.7787 3C17.9767 3 22.1905 7.21379 22.1905 12.4118C22.1905 17.6097 17.9767 21.8235 12.7787 21.8235C9.49343 21.8235 6.6013 20.1403 4.9177 17.5892L5.74985 17.0344C7.25412 19.3171 9.84049 20.8235 12.7787 20.8235ZM12.2787 6.5294V13V13.23L12.4533 13.3796L16.571 16.909L17.2218 16.1498L13.2787 12.77V6.5294H12.2787Z",
    fill: "#525355"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.4118L4 13.4118L7 11.4118",
    stroke: "#525355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.d7482afcc007fae9736924847267a5b7.svg";
export { ForwardRef as ReactComponent };